import { inject } from '@angular/core';

import { TokenService } from '../services/token.service';
import { VerificaContactoService } from '../services/validador-contacto.service';

export async function initializeToken(): Promise<void> {
  // ⚠️ IMPORTANTE: No ejecutar el initializer en rutas de ClaveÚnica
  // El flujo de ClaveÚnica tiene su propia lógica de autenticación
  const currentPath = window.location.pathname;
  if (currentPath.startsWith('/claveunica')) {
    return;
  }

  const tokenService = inject(TokenService);
  const verificaContactoService = inject(VerificaContactoService);

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('s');

  if (token) {
    tokenService.setToken(token);

    const url = new URL(window.location.href);
    url.searchParams.delete('s');
    window.history.replaceState({}, '', url.toString());

    try {
      const data = await verificaContactoService.getContactData();

      tokenService.verificacionContactoOk(data);
    } catch (err) {
      console.error('Error obteniendo datos de contacto:', err);
      tokenService.verificacionContactoError();
    }
  } else {
    if (tokenService.hasPersistedData()) {
      if (tokenService.hasContactData()) {
        tokenService.setInitializationComplete();
        tokenService.setOtpState();
      } else {
        try {
          const data = await verificaContactoService.getContactData();

          tokenService.verificacionContactoOk(data);
        } catch (err) {
          console.error(
            'Error obteniendo datos de contacto desde token persistido:',
            err
          );
          tokenService.verificacionContactoError();
        }
      }
    } else {
      tokenService.verificacionContactoNotFound();
    }
  }
}
